// extracted by mini-css-extract-plugin
export var wordContainer = "_ps-0";